import { render, staticRenderFns } from "./supercSaleDetail.vue?vue&type=template&id=1508d682&"
import script from "./supercSaleDetail.vue?vue&type=script&lang=js&"
export * from "./supercSaleDetail.vue?vue&type=script&lang=js&"
import style0 from "./supercSaleDetail.vue?vue&type=style&index=0&id=1508d682&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports